import { IDeleteEntity } from "interfaces/delete-entity";
import { GraphQLData } from "interfaces/graphql-data";
import { ITenant } from "interfaces/tenant";

export class DeleteTenantModel implements IDeleteEntity, GraphQLData {
  lastEvaluatedKey: string = '';
  deleted: boolean = false;

  public static create(
    deleted: boolean) : DeleteTenantModel {
    const t = new DeleteTenantModel();
    t.deleted = deleted;
    return t;
  }

  async hydrate(data: any, tenant: ITenant): Promise<void> {
    //..
    // data.data.GetTenant.Deleted (true)
    console.log(data);
    if (data && data.data && data.data.GetTenant && data.data.GetTenant.Delete) {
      this.deleted = data.data.GetTenant.Delete;
    } else {
      throw new Error('data structured passed in does not contain data, data.data, data.data.GetTenant or data.data.GetTenant.Delete');
    }
  }
}